import * as z from "zod";

const PhaseInstanceRefSchema = z.object({
  id: z.string(),
});

export const PhaseSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  color: z.string(),
  type: z.string().nullable().optional(),
  order: z.string().optional(),
  icon: z.string().nullable().optional(),
  iconType: z.string().nullable().optional(),
  isCompleted: z.boolean().optional(),
  instanceList: z.array(PhaseInstanceRefSchema).optional(),
});

export type Phase = z.infer<typeof PhaseSchema>;

export type CreatePhaseInput = {
  workspaceId: string;
  name: string;
  color: string;
  icon?: string | null;
  iconType?: string | null;
  isCompleted?: boolean;
};

export const PhaseInstanceSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  ownerId: z.string(),
  ownerType: z.string(),
  phaseId: z.string(),
  phase: PhaseSchema,
});

export type PhaseInstance = z.infer<typeof PhaseInstanceSchema>;
